// extracted by mini-css-extract-plugin
export default {"root":"styles_root__ldk0R","wrapper":"styles_wrapper__FpKoy","error":"styles_error__hhWL-"};